<div class="container">
  <div class="row">
    <div class="col-12 text-center mt-5 pt-5">
      <h4>LocalStorage pulito</h4>
    </div>
  </div>
</div>
